import React from 'react';

interface Props {
  count: number;
  isJustified: boolean;
}

export const AttendanceCountChip: React.FC<Props> = ({
  count,
  isJustified,
}) => (
  <span
    className={`text-subhead-14 flex shrink-0 items-center justify-center rounded-xl px-2 py-0.5 ${isJustified ? 'bg-purple-soft text-primary' : 'bg-red-soft text-foreground'}`}
  >
    {count}
  </span>
);
